import React from 'react';
import styled from 'styled-components';
import { theme } from '../theme';

const TermsContainer = styled.div`
  padding: ${theme.spacing.xl};
  max-height: 80vh;
  overflow-y: auto;
  font-family: ${theme.typography.fontFamily.primary};
  line-height: 1.6;
  color: ${theme.colors.text.primary};

  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: ${theme.spacing.lg};
    max-height: 85vh;
  }
`;

const Title = styled.h1`
  font-size: ${theme.typography.fontSize.xxl};
  font-weight: ${theme.typography.fontWeight.bold};
  color: ${theme.colors.text.primary};
  text-align: center;
  margin-bottom: ${theme.spacing.xl};
  font-family: ${theme.typography.fontFamily.secondary};
`;

const UpdateDate = styled.p`
  text-align: center;
  color: ${theme.colors.text.secondary};
  font-size: ${theme.typography.fontSize.sm};
  margin-bottom: ${theme.spacing.xl};
`;

const Section = styled.section`
  margin-bottom: ${theme.spacing.xl};
`;

const SectionTitle = styled.h2`
  font-size: ${theme.typography.fontSize.lg};
  font-weight: ${theme.typography.fontWeight.bold};
  color: ${theme.colors.text.primary};
  margin-bottom: ${theme.spacing.md};
  border-bottom: 1px solid ${theme.colors.border.light};
  padding-bottom: ${theme.spacing.xs};
`;

const SubSection = styled.div`
  margin-bottom: ${theme.spacing.md};
`;

const SubSectionTitle = styled.h3`
  font-size: ${theme.typography.fontSize.md};
  font-weight: ${theme.typography.fontWeight.semibold};
  color: ${theme.colors.text.primary};
  margin-bottom: ${theme.spacing.sm};
`;

const Paragraph = styled.p`
  font-size: ${theme.typography.fontSize.sm};
  margin-bottom: ${theme.spacing.md};
  text-align: justify;
`;

const BulletList = styled.ul`
  margin: ${theme.spacing.sm} 0 ${theme.spacing.md} ${theme.spacing.lg};
  padding-left: 0;
  
  li {
    font-size: ${theme.typography.fontSize.sm};
    margin-bottom: ${theme.spacing.xs};
    line-height: 1.5;
  }
`;

const ContactInfo = styled.div`
  background: ${theme.colors.surface};
  border: 1px solid ${theme.colors.border.light};
  border-radius: 8px;
  padding: ${theme.spacing.lg};
  margin-top: ${theme.spacing.xl};
`;

const TermsOfService: React.FC = () => {
  return (
    <TermsContainer>
      <Title>服务条例</Title>
      <UpdateDate>更新日期：2025年11月7日</UpdateDate>
      
      <Paragraph>
        欢迎您使用"厨记"App！
      </Paragraph>
      
      <Paragraph>
        本《软件服务协议》（以下简称"本协议"）是您（以下简称"用户"或"您"）与湖州厨记科技有限公司之间就您下载、安装、使用"厨记"App（以下简称"本软件"）相关服务所订立的协议。
      </Paragraph>

      <Section>
        <SectionTitle>一、服务内容</SectionTitle>
        <SubSection>
          <SubSectionTitle>1.1</SubSectionTitle>
          <Paragraph>
            本软件是一款主要为用户提供菜谱查询、美食制作步骤学习、个人烹饪记录与分享等功能的应用程序。
          </Paragraph>
        </SubSection>
        <SubSection>
          <SubSectionTitle>1.2</SubSectionTitle>
          <Paragraph>
            本公司授权您一项个人的、不可转让的、非独占的使用本软件的权利。
          </Paragraph>
        </SubSection>
        <SubSection>
          <SubSectionTitle>1.3</SubSectionTitle>
          <Paragraph>
            本公司可能根据实际运营情况对服务内容进行变更、升级或中断，并将尽可能提前进行通知。
          </Paragraph>
        </SubSection>
      </Section>

      <Section>
        <SectionTitle>二、用户账号</SectionTitle>
        <SubSection>
          <SubSectionTitle>2.1</SubSectionTitle>
          <Paragraph>
            您可能需要注册账号才能使用本软件的部分功能。您承诺提交的注册信息真实、准确、完整。
          </Paragraph>
        </SubSection>
        <SubSection>
          <SubSectionTitle>2.2</SubSectionTitle>
          <Paragraph>
            您应妥善保管账号及密码，并对在该账号下进行的所有活动承担责任。如发现任何未经授权的使用，应立即通知本公司。
          </Paragraph>
        </SubSection>
      </Section>

      <Section>
        <SectionTitle>三、用户行为规范</SectionTitle>
        <SubSection>
          <SubSectionTitle>3.1</SubSectionTitle>
          <Paragraph>
            您同意遵守中华人民共和国相关法律法规及所有适用于本软件的网络协议、规定和程序。
          </Paragraph>
        </SubSection>
        <SubSection>
          <SubSectionTitle>3.2</SubSectionTitle>
          <Paragraph>
            您不得利用本软件从事以下行为：
          </Paragraph>
          <BulletList>
            <li>上传、发布、传播含有违反国家法律法规、危害国家安全、破坏民族团结、扰乱社会秩序等内容的信息；</li>
            <li>侵犯他人知识产权、肖像权、隐私权等合法权益；</li>
            <li>从事任何破坏本软件服务或影响他人正常使用的行为，如传播病毒、发起恶意爬虫等；</li>
            <li>未经本公司许可，进行任何形式的商业广告行为；</li>
            <li>其他本公司合理认为不适当的行为。</li>
          </BulletList>
        </SubSection>
        <SubSection>
          <SubSectionTitle>3.3</SubSectionTitle>
          <Paragraph>
            您理解并同意，您在本软件上公开分享的内容（如菜谱、笔记、图片等），视为您授予本公司一项全球范围内、免费、永久的许可，本公司有权在本软件及关联服务中使用、展示、传播这些内容。
          </Paragraph>
        </SubSection>
      </Section>

      <Section>
        <SectionTitle>四、知识产权声明</SectionTitle>
        <SubSection>
          <SubSectionTitle>4.1</SubSectionTitle>
          <Paragraph>
            本公司拥有本软件的整体内容（包括但不限于界面设计、流程图、源代码、商标等）的著作权、商标权等一切知识产权。
          </Paragraph>
        </SubSection>
        <SubSection>
          <SubSectionTitle>4.2</SubSectionTitle>
          <Paragraph>
            本软件向您提供的菜谱、图片、文字等内容，其知识产权归本公司或原始权利人所有。您仅可为个人学习、研究的目的使用，未经许可，不得进行任何形式的复制、修改、转载或用于商业用途。
          </Paragraph>
        </SubSection>
      </Section>

      <Section>
        <SectionTitle>五、付费服务</SectionTitle>
        <SubSection>
          <SubSectionTitle>5.1</SubSectionTitle>
          <Paragraph>
            本软件部分高级功能可能需要您支付费用方可使用（以下简称"付费服务"）。具体服务内容、资费标准以本软件内公示为准。
          </Paragraph>
        </SubSection>
        <SubSection>
          <SubSectionTitle>5.2</SubSectionTitle>
          <Paragraph>
            自动续费服务（如适用）：
          </Paragraph>
          <Paragraph>
            如果您订阅的付费服务是自动续费类型，则您授权本公司可在订阅周期到期前24小时内，从您的iTunes账户中扣除下一周期的费用。若您需要取消自动订阅，您必须在当前订阅周期到期前至少24小时，手动在您的iPhone/iPad &quot;设置&quot; -&gt; &quot;[Apple ID]&quot; -&gt; &quot;订阅&quot; 管理中关闭自动续订功能。
          </Paragraph>
        </SubSection>
      </Section>

      <Section>
        <SectionTitle>六、隐私保护</SectionTitle>
        <SubSection>
          <SubSectionTitle>6.1</SubSectionTitle>
          <Paragraph>
            保护用户隐私是我们的基本原则。本公司将严格按照单独公布的《隐私政策》收集、使用、存储和保护您的个人信息。
          </Paragraph>
        </SubSection>
        <SubSection>
          <SubSectionTitle>6.2</SubSectionTitle>
          <Paragraph>
            您在使用本服务过程中，可能需要提供一些必要的个人信息，例如为完成注册需要您提供手机号码。您须保证这些信息的真实性、准确性。
          </Paragraph>
        </SubSection>
        <SubSection>
          <SubSectionTitle>6.3</SubSectionTitle>
          <Paragraph>
            未经您同意，本公司不会向任何第三方公开、透露您的个人信息，但以下情况除外：
          </Paragraph>
          <BulletList>
            <li>根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；</li>
            <li>为您提供您需要的服务所必须的；</li>
            <li>根据本公司单独公布的《隐私政策》或其他相关规定。</li>
          </BulletList>
        </SubSection>
      </Section>

      <Section>
        <SectionTitle>七、免责与责任限制</SectionTitle>
        <SubSection>
          <SubSectionTitle>7.1</SubSectionTitle>
          <Paragraph>
            本软件提供的菜谱及烹饪步骤仅供参考。您因依赖这些信息进行烹饪而导致的任何食物中毒、烫伤或其他人身或财产损害，本公司不承担任何责任。请您在操作时注意安全。
          </Paragraph>
        </SubSection>
        <SubSection>
          <SubSectionTitle>7.2</SubSectionTitle>
          <Paragraph>
            本公司将尽力保障服务的连续性和稳定性，但对于因不可抗力（如自然灾害、政府行为、网络服务中断等）、计算机病毒、黑客攻击等导致的服务中断或数据丢失，本公司不承担责任。
          </Paragraph>
        </SubSection>
        <SubSection>
          <SubSectionTitle>7.3</SubSectionTitle>
          <Paragraph>
            在任何情况下，本公司的赔偿责任不应超过您在过去12个月内因使用本服务而向本公司支付的费用总额（如有）。
          </Paragraph>
        </SubSection>
      </Section>

      <Section>
        <SectionTitle>八、协议变更与终止</SectionTitle>
        <SubSection>
          <SubSectionTitle>8.1</SubSectionTitle>
          <Paragraph>
            本公司有权在必要时修改本协议条款。更新后的协议将在本软件上公布，并通过适当方式提醒您。您如果不同意修改后的协议，有权停止使用本服务。如果您继续使用，则视为您已接受修改后的协议。
          </Paragraph>
        </SubSection>
        <SubSection>
          <SubSectionTitle>8.2</SubSectionTitle>
          <Paragraph>
            您有权随时通过永久删除本软件来终止本协议。
          </Paragraph>
        </SubSection>
        <SubSection>
          <SubSectionTitle>8.3</SubSectionTitle>
          <Paragraph>
            如您严重违反本协议，本公司有权暂停或终止向您提供服务。
          </Paragraph>
        </SubSection>
      </Section>

      <Section>
        <SectionTitle>九、法律适用与争议解决</SectionTitle>
        <SubSection>
          <SubSectionTitle>9.1</SubSectionTitle>
          <Paragraph>
            本协议的订立、执行、解释及争议解决均适用中华人民共和国法律。
          </Paragraph>
        </SubSection>
        <SubSection>
          <SubSectionTitle>9.2</SubSectionTitle>
          <Paragraph>
            因本协议引起的或与本协议有关的任何争议，双方应首先友好协商解决；协商不成的，任何一方均有权将争议提交至湖州厨记科技有限公司所在地有管辖权的人民法院诉讼解决。
          </Paragraph>
        </SubSection>
      </Section>

      <Section>
        <SectionTitle>十、其他</SectionTitle>
        <SubSection>
          <SubSectionTitle>10.1</SubSectionTitle>
          <Paragraph>
            本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。
          </Paragraph>
        </SubSection>
        <SubSection>
          <SubSectionTitle>10.2</SubSectionTitle>
          <Paragraph>
            本公司未行使本协议的任何权利或规定，不构成对该权利或规定的放弃。
          </Paragraph>
        </SubSection>
      </Section>

      <ContactInfo>
        <Paragraph style={{ marginBottom: theme.spacing.sm }}>
          如果您对本协议有任何疑问，欢迎通过以下方式联系我们：
        </Paragraph>
        <Paragraph style={{ marginBottom: theme.spacing.xs }}>
          客服邮箱：chuji_fun@163.com
        </Paragraph>
        <Paragraph style={{ margin: 0 }}>
          公司名称：湖州厨记科技有限公司
        </Paragraph>
      </ContactInfo>
    </TermsContainer>
  );
};

export default TermsOfService;
